import { Country } from '../locale/countries';

export interface CreateCustomerRequest {
  emailAddress: string;
  lastName: string;
  firstName: string;
  postCode?: string;
  location: Country;
}
